import React, { useState, useEffect } from "react";
import { MDBProgress, MDBProgressBar } from 'mdb-react-ui-kit';

import splash1 from "../../assets/images/ttt1.png";
import splash2 from "../../assets/images/ttt2.png";
import splash3 from "../../assets/images/ttt3.png";
import '../../assets/styles/SplashScreen.css';

export default function SplashScreen(props) {
    let currentIndex = 0;
    const maxIndex = 3;

    const alternateImages = () => {
        const listOfScreens = document.getElementsByClassName('splash-screen-image');
        const activeScreen = document.getElementsByClassName('active')[0];
        activeScreen.classList.remove("active");
        currentIndex = (currentIndex + 1) % maxIndex;
        const newActiveScreen = listOfScreens[currentIndex];
        newActiveScreen.classList.add("active");
    }
    
    useEffect(() => {
        const interval = setInterval(alternateImages, 4000);
        return () => clearInterval(interval);
    }, []);

    return(<div className={`splash-screen-background ${props.loader > 100 ? "fadeOut" : ""}`}>
        <div className="splash-screen-parent ">
            <img className="splash-screen-image active" src={splash1} />
            <img className="splash-screen-image" src={splash2} />
            <img className="splash-screen-image" src={splash3} />
            <div className="progress-bar-parent">
                <MDBProgress height='20'>
                    <MDBProgressBar width={props.loader} valuemin={0} valuemax={100} />
                </MDBProgress>
            </div>
        </div>
    </div>)

}